/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_Payment_TitleInputs */

const en_landing_features_payment_title = /** @type {(inputs: Landing_Features_Payment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

const zh_landing_features_payment_title = /** @type {(inputs: Landing_Features_Payment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付系统`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {Landing_Features_Payment_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_payment_title = /** @type {((inputs?: Landing_Features_Payment_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_Payment_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_payment_title(inputs)
	return zh_landing_features_payment_title(inputs)
});
export { landing_features_payment_title as "landing.features.payment.title" }